import { useCallback } from 'react';

import type { NWTEvent } from '@xing-com/crate-communication-tracking';
import { useTracking } from '@xing-com/crate-communication-tracking';

type SharedEventProps = 'application' | 'type' | 'element';

const defaultTrackingParams: Pick<NWTEvent, SharedEventProps> = {
  type: 'nwt',
  application: 'wbm',
  element: 'display_ad',
};

const getElementDetail = (adUnitPath: string, isPublift?: boolean): string => {
  // /53015287,23277432748/xing.com_d_970x250_1
  const marker = 'xing.com_';

  // /71161633,23277432748/XING_xing/Homepage_HREC_1
  const publiftMarker = '_xing/';

  const pathParts = adUnitPath.split(isPublift ? publiftMarker : marker);

  if (pathParts.length < 2 || !pathParts[1]) {
    return '';
  }

  return pathParts[1];
};

export const useDisplayAdTracking = ({
  sentBy,
  page,
  isPublift,
}: {
  sentBy: string;
  page: string;
  isPublift?: boolean;
}): {
  onViewableListener: (event: googletag.events.ImpressionViewableEvent) => void;
} => {
  const { track } = useTracking();

  const trackImpression = useCallback(
    (elementDetail: string): void => {
      track({
        ...defaultTrackingParams,
        eventSchema: 'basic',
        event: 'entered_viewport',
        elementDetail,
        sentBy,
        page,
      });
    },
    [page, sentBy, track]
  );

  const onViewableListener = useCallback(
    (event: googletag.events.ImpressionViewableEvent): void => {
      const mappedAdUnitPath = isPublift
        ? // @ts-expect-error Publift uses different types. Align after a/b test.
          getElementDetail(event.gptEvent.slot.getAdUnitPath(), true)
        : getElementDetail(event.slot.getAdUnitPath());

      trackImpression(mappedAdUnitPath);
    },
    [isPublift, trackImpression]
  );

  return { onViewableListener };
};
